// Cross-check USD evidence with the independent native-gas summary and position history.
export const historicalMatchesPositions = (evidence,positions,rows,expectedCost) => {
  const states=new Map(), epochs=new Map();
  let cost=0n;
  for (const e of evidence) {
    const epoch=epochs.get(e.token) || 1;
    if (e.epoch!==epoch) return false;
    if (e.side==='retire') {
      const entries=[...states.values()].filter(s=>s.position.token===e.token && s.position.epoch===epoch);
      if (e.bot_hash!==null || !entries.length || entries.some(s=>s.retired || s.position.status!=='retired')
          || entries.reduce((n,s)=>n+s.quantity,0n)!==BigInt(e.quantity)) return false;
      for (const state of entries) { cost+=state.usd; state.retired=true; }
      cost+=BigInt(e.gas_usd6); epochs.set(e.token,epoch+1);
      continue;
    }
    const p=positions.find(v=>v.token===e.token && v.bot_hash===e.bot_hash && v.epoch===e.epoch);
    if (!p) return false;
    const s=states.get(p.id) || {position:p,quantity:0n,usd:0n,native:0n,allocated:0n,exitGas:0n,count:0,sells:0,buys:[],retired:false};
    if (s.retired) return false;
    const q=BigInt(e.quantity), usd=BigInt(e.gas_usd6), native=BigInt(e.gas_wei);
    if (q<=0n) return false;
    if (e.side==='buy') { s.quantity+=q; s.usd+=usd; s.native+=native; s.buys.push(e.transaction_hash); }
    else {
      if (q>s.quantity || !s.quantity) return false;
      const allocation=(s.usd*q+s.quantity-1n)/s.quantity;
      const nativeAllocation=(s.native*q+s.quantity-1n)/s.quantity;
      s.quantity-=q; s.usd-=allocation; s.native-=nativeAllocation;
      s.allocated+=nativeAllocation; s.exitGas+=native; s.sells+=1;
      cost+=allocation+usd;
    }
    s.count+=1; states.set(p.id,s);
  }
  if (states.size!==positions.length || cost!==BigInt(expectedCost)) return false;
  return positions.every(p=>{
    const s=states.get(p.id), row=rows.find(r=>r.position_id===p.id);
    return s && row && s.quantity===BigInt(p.quantity) && s.retired===(p.status==='retired')
      && row.gas_status==='receipt_confirmed' && row.receipt_count===s.count && row.realized_exits===s.sells
      && BigInt(row.allocated_entry_gas_wei)===s.allocated && BigInt(row.exit_gas_wei)===s.exitGas
      && BigInt(row.remaining_entry_gas_wei)===s.native && BigInt(row.realized_gas_wei)===s.allocated+s.exitGas
      && Array.isArray(p.purchase_transactions) && p.purchase_transactions.length===s.buys.length
      && p.purchase_transactions.every((hash,i)=>hash===s.buys[i]);
  });
};